import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Directive({
  selector: '[appAccessControl]'
})
export class AccessControlDirective implements OnInit {
  @Input() accessRoles!: string;
  @Input() accessPermissions!: string;
  constructor(private elementRef: ElementRef, private auth: AuthenticationService) { }

  ngOnInit() {
    this.checkAccess();
  }

  checkAccess() {
    if (!this.checkAccessRoles() || !this.checkAccessPermissions()) {
      this.elementRef.nativeElement.remove();
    }
  }

  checkAccessRoles(): boolean {
    const accessControls: string[] = this.auth.currentUserValue?.UserRoles ?? [];
    const accessRolesList = this.accessRoles?.split(',') || [];
    const founded = [];
    accessRolesList.forEach(role => {
      const found = accessControls.some(control => control === role);
      if (found) { founded.push(role); }
    });

    if (!founded.length && accessRolesList.length) {
      return false;
    }
    return true;
  }

  checkAccessPermissions(): boolean {
    const accessControls: string[] = this.auth.currentUserValue?.Permissions ?? [];
    const accessPermissionsList = this.accessPermissions?.split(',') || [];
    const founded = [];
    accessPermissionsList.forEach(permission => {
      const found = accessControls.some(control => control === permission);
      if (found) { founded.push(permission); }
    });

    if (!founded.length && accessPermissionsList.length) {
      // console.log(accessPermissionsList.length)
      return false;
    }
    return true;
  }
}
